/* unplugin-vue-components disabled */import { render } from "./comp1.vue?vue&type=template&id=8476527e&scoped=true"
import script from "./comp1.vue?vue&type=script&lang=js"
export * from "./comp1.vue?vue&type=script&lang=js"

import "./comp1.vue?vue&type=style&index=0&id=8476527e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8476527e"]])

export default __exports__